import { Skeleton, Space } from 'antd';
import React from 'react';

const PageSkeleton = ({ 
  rows = 4,           // Number of content rows
  avatar = false,     // Show avatar at top
  title = true,       // Show title bar
  paragraph = true,   // Show paragraph lines
}) => {
  return (
    <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      <Space direction="vertical" style={{ width: '100%' }} size="large">
        {title && <Skeleton.Input active style={{ width: 300, height: 32 }} />}
        <Skeleton 
          active 
          avatar={avatar}
          paragraph={{ rows }}
        />
      </Space>
    </div>
  );
};

export default PageSkeleton;
